.tableHeaderComponentContainer {
	min-width: 100%;
	padding: 30px 180px 0 50px;
}
